export const PLOT_CARD_IDS = {
  MACHINERY_GRID: 171923438714,
  BUFFER_ZONE: 171923438713,
  AB_LINE_BASE: 171923438715,
  TRIAL_PLOTS_BASE: 171923438712,
} as const;
